import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import PolicyConfigTab from "./PolicyConfigTab";
import PartnerRulesTab from "./PartnerRulesTab";
import ScorecardTab from "./ScorecardTab";
import LtvMatrixTab from "./LtvMatrixTab";
import RuleSimulatorTab from "./RuleSimulatorTab";
import ExceptionMatrixTab from "./ExceptionMatrixTab";
import PolicyAuditTab from "./PolicyAuditTab";

export default function CreditPolicyEngine() {
  return (
    <div data-testid="credit-policy-engine">
      <div className="mb-5">
        <h1 className="text-2xl font-semibold text-slate-900">Credit Policy Engine</h1>
        <p className="text-sm text-slate-600 mt-1">
          Red Fort Capital board-approved credit policy — configurable rules drive the live valuation, eligibility and risk engines.
        </p>
      </div>
      <Tabs defaultValue="policy" className="space-y-4">
        <TabsList className="bg-slate-100 flex-wrap h-auto">
          <TabsTrigger value="policy" data-testid="policy-tab-rfc">RFC Policy</TabsTrigger>
          <TabsTrigger value="partners" data-testid="policy-tab-partners">Partner Rules</TabsTrigger>
          <TabsTrigger value="scorecard" data-testid="policy-tab-scorecard">Scorecard Builder</TabsTrigger>
          <TabsTrigger value="matrix" data-testid="policy-tab-matrix">LTV / ROI Matrix</TabsTrigger>
          <TabsTrigger value="simulator" data-testid="policy-tab-simulator">Rule Simulator</TabsTrigger>
          <TabsTrigger value="exceptions" data-testid="policy-tab-exceptions">Exception Matrix</TabsTrigger>
          <TabsTrigger value="audit" data-testid="policy-tab-audit">Audit Log</TabsTrigger>
        </TabsList>
        <TabsContent value="policy"><PolicyConfigTab /></TabsContent>
        <TabsContent value="partners"><PartnerRulesTab /></TabsContent>
        <TabsContent value="scorecard"><ScorecardTab /></TabsContent>
        <TabsContent value="matrix"><LtvMatrixTab /></TabsContent>
        <TabsContent value="simulator"><RuleSimulatorTab /></TabsContent>
        <TabsContent value="exceptions"><ExceptionMatrixTab /></TabsContent>
        <TabsContent value="audit"><PolicyAuditTab /></TabsContent>
      </Tabs>
    </div>
  );
}
